document.querySelectorAll('[data-fibrax-products]').forEach((root) => {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady = 'true';

  const cards = [...root.querySelectorAll('[data-fx-product-card]')];
  const tabs = [...root.querySelectorAll('[data-fx-category]')];
  const search = root.querySelector('[data-fx-search]');
  const sort = root.querySelector('[data-fx-sort]');
  const grid = root.querySelector('[data-fx-catalog-grid]');
  const count = root.querySelector('[data-fx-count]');
  const empty = root.querySelector('[data-fx-empty]');
  let category = 'all';

  const apply = () => {
    const term = (search?.value || '').trim().toLocaleLowerCase('es-MX');
    const visible = cards.filter((card) => {
      const categoryMatch = category === 'all' || card.dataset.category === category;
      const termMatch = !term || (card.dataset.search || '').includes(term);
      const show = categoryMatch && termMatch;
      card.hidden = !show;
      return show;
    });

    if (sort && grid) {
      const mode = sort.value;
      const sorted = [...visible].sort((a, b) => {
        if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'es');
      });
      sorted.forEach((card) => grid.appendChild(card));
    }

    if (count) count.textContent = visible.length.toLocaleString('es-MX');
    if (empty) empty.hidden = visible.length > 0;
  };

  tabs.forEach((tab) => tab.addEventListener('click', () => {
    category = tab.dataset.fxCategory;
    tabs.forEach((item) => item.classList.toggle('is-active', item === tab));
    apply();
  }));
  search?.addEventListener('input', apply);
  sort?.addEventListener('change', apply);

  root.querySelectorAll('[data-fx-add-product]').forEach((button) => {
    button.addEventListener('click', () => window.FibraxCore.addToCart({
      variantId: button.dataset.variantId,
      quantity: 1,
      root,
      button,
      properties: { Origen: 'Catálogo FIBRAX' }
    }));
  });
  apply();
});
